import React, { useState, useEffect } from 'react';

const Results_You_Can_Feel = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Dummy testimonials data with Indian names (fallback values)
  const dummyTestimonials = [
    {
      id: 1,
      customer_name: "Priya Sharma",
      review: "I've been using Evercore for 3 months now and the results are incredible! My energy levels are through the roof and I've never felt better. Highly recommend to anyone looking for a natural boost.",
      rating: 5,
      created_at: "2024-01-15",
      status: "approved"
    },
    {
      id: 2,
      customer_name: "Rajesh Kumar",
      review: "Finally found a supplement that actually works. My recovery time after workouts has significantly improved. Evercore has become an essential part of my daily routine.",
      rating: 5,
      created_at: "2024-01-10",
      status: "approved"
    },
    {
      id: 3,
      customer_name: "Anjali Mehta",
      review: "Great product! I noticed a difference in my focus and productivity within the first week. The quality is outstanding and customer service is top-notch.",
      rating: 4,
      created_at: "2024-01-05",
      status: "approved"
    },
    {
      id: 4,
      customer_name: "Vikram Singh",
      review: "As a fitness trainer, I'm always skeptical about supplements. Evercore exceeded my expectations. My clients are seeing amazing results too!",
      rating: 5,
      created_at: "2024-01-12",
      status: "approved"
    },
    {
      id: 5,
      customer_name: "Neha Gupta",
      review: "The energy boost without the jitters is exactly what I needed. Perfect for my busy lifestyle. Will definitely be ordering again!",
      rating: 5,
      created_at: "2024-01-08",
      status: "approved"
    },
    {
      id: 6,
      customer_name: "Amit Patel",
      review: "Outstanding product! My sleep quality has improved and I wake up feeling refreshed. Evercore is a game-changer.",
      rating: 4,
      created_at: "2024-01-03",
      status: "approved"
    },
    {
      id: 7,
      customer_name: "Sunita Reddy",
      review: "Perfect for working mothers like me. Sustained energy throughout the day without any crash. My productivity has doubled!",
      rating: 5,
      created_at: "2024-01-18",
      status: "approved"
    },
    {
      id: 8,
      customer_name: "Arjun Nair",
      review: "Started seeing results within 2 weeks. My digestion has improved and I feel more active. Worth every rupee!",
      rating: 5,
      created_at: "2024-01-14",
      status: "approved"
    },
    {
      id: 9,
      customer_name: "Kavita Joshi",
      review: "Finally something that works for Indian bodies and lifestyle. My immunity has improved significantly. Thank you Evercore!",
      rating: 5,
      created_at: "2024-01-09",
      status: "approved"
    }
  ];

  // Get random dummy testimonials
  const getRandomDummyTestimonials = () => {
    const shuffled = [...dummyTestimonials].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 3);
  };

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch('https://evercorenutrition.com/ev_admin/api/reviews/approved/', {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch reviews: ${response.status}`);
        }

        const data = await response.json();
        
        if (data.results && data.results.reviews && Array.isArray(data.results.reviews) && data.results.reviews.length > 0) {
          const approvedReviews = data.results.reviews.filter(review => review.status === 'approved');
          
          if (approvedReviews.length > 0) {
            const shuffled = [...approvedReviews].sort(() => 0.5 - Math.random());
            const randomThree = shuffled.slice(0, 3);
            setTestimonials(randomThree);
          } else {
           
            setTestimonials(getRandomDummyTestimonials());
          }
        } else {
          
          setTestimonials(getRandomDummyTestimonials());
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching testimonials:', err);
        setTestimonials(getRandomDummyTestimonials());
        setError(null);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // Helper function to render star rating
  const renderStars = (rating) => {
    return Array(5).fill(0).map((_, i) => (
      <span
        key={i}
        className={i < rating ? 'results-review-star filled' : 'results-review-star'}
        style={{ color: i < rating ? '#FFD700' : '#e4e5e9' }}
      >
        ★
      </span>
    ));
  };

  // Helper function to format date nicely
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (loading) {
    return (
      <section className="blog-section">
        <div className="container-fluid-lg">
          <div className="title d-block" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
            <h2>Results You Can Feel</h2>
            <span className="title-leaf">
              <svg className="icon-width">
                <use href="../assets/svg/leaf.svg#leaf"></use>
              </svg>
            </span>
            <p>From workouts to workdays, Evercore fits into real lives.</p>
          </div>
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading testimonials...</span>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="blog-section">
        <div className="container-fluid-lg">
          <div className="title d-block" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
            <h2>Results You Can Feel</h2>
            <span className="title-leaf">
              <svg className="icon-width">
                <use href="../assets/svg/leaf.svg#leaf"></use>
              </svg>
            </span>
            <p>From workouts to workdays, Evercore fits into real lives.</p>
          </div>
          <div className="text-center py-5">
            <p className="text-danger">Unable to load testimonials at this time.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="blog-section">
      <div className="container-fluid-lg">
        <div className="title d-block" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
          <h2>Results You Can Feel</h2>
          <span className="title-leaf">
            <svg className="icon-width">
              <use href="../assets/svg/leaf.svg#leaf"></use>
            </svg>
          </span>
          <p>From workouts to workdays, Evercore fits into real lives.</p>
        </div>

        <div className="row g-4">
          {testimonials.length > 0 ? (
            testimonials.map((testimonial) => (
              <div key={testimonial.id} className="col-lg-4 col-md-6">
                {/* Added inline style for fixed height - original CSS preserved */}
                <div 
                  className="results-review-card"
                  style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                >
                  <div 
                    className="results-review-card-detail"
                    style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
                  >
                    {/* Review text with fixed height wrapper */}
                    <div style={{ flex: 1 }}>
                      <p className="results-review-card-text">
                        "{testimonial.review}"
                      </p>
                    </div>
                    
                    {/* Star Rating */}
                    <div className="results-review-stars mb-2">
                      {renderStars(testimonial.rating)}
                    </div>
                    
                    <div className="results-review-card-reviewer">
                      <h4 className="results-review-card-name">
                        {testimonial.customer_name}
                      </h4>
                      <span className="results-review-card-role d-block">
                        Verified Customer
                      </span>
                      {testimonial.created_at && (
                        <span className="results-review-card-date small text-muted">
                          {formatDate(testimonial.created_at)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="text-center py-4">
                <p>No verified customer reviews yet. Be the first to share your experience!</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Results_You_Can_Feel;